<template>
  <overview-table
    title="Gratuidades - Pré Impressões"
    :headers="headers"
    :items="items"
    :footers="[footer]"
  >
    <template #[`item.type`]="{ item }">
      <span>{{ item.sector_name }} ({{ item.free_name }})</span>
    </template>
    <template #no-data>
      <h4>Ainda não existem gratuidades pré impressas para este evento.</h4>
    </template>
  </overview-table>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type Overview from '@/types/Overview'
import OverviewTable from './partials/OverviewTable.vue'

const { overview } = defineProps<{ overview: Overview }>()

// --- Items ---
const items = computed(() => {
  return overview.summary.filter(item => item.origin === 'pre_impressao' && item.ticket_type_name === 'Gratuidade')
})

// --- Header ---
const headers = ref([
  { key: 'type', value: 'type', title: 'Tipo', sortable: false },
  { key: 'batch', value: 'batch', title: 'Lote', sortable: true },
  { key: 'generated', value: 'generated', title: 'Gerados', sortable: true },
  { key: 'printed', value: 'printed', title: 'Impressos', sortable: true },
  { key: 'read', value: 'read', title: 'Computados', sortable: true },
])

// --- Footer ---
const footer = computed(
  () => ({
    type: 'Total',
    generated: items.value.reduce((prev, next) => prev + next.generated, 0),
    printed: items.value.reduce((prev, next) => prev + next.printed, 0),
    read: items.value.reduce((prev, next) => prev + next.read, 0),
  }),
)

</script>
